// fourColorCanvas()
// give it:
// - four colors 
// - a color space
// - and some output dimensions
// and it returns a (P3!) <canvas> with the four colors at the four corners
// and all the rest of its pixels interpolated between 'em, in the color space

import {
	to as convert,
	ColorSpace,
	P3
} from "../node_modules/colorjs.io/src/index-fn.js";
import fourColorMixFn from './fourColorMixFn.js';
import percentToOctal from './percentToOctal.js';
import reorderArray from './reorderarray.js';

const displayP3 = ColorSpace.register(P3);

/*
fourColors order
1-----3
|     |
|     |
0-----2
*/

export default function fourColorCanvas(
	fourColors, // Array<4 * Array<3 * Number>>
	            // e.g., [ [ 0,0,0 ], [1,0,0], [0,1,0], [1,1,0] ]
	            // see order above
	inputSpace, // a Color.js ColorSpace
	dimensions // Array<2 * Number>, e.g., [800,600]
) {
	
	// setup
	const canvas = document.createElement('canvas');
	canvas.width = dimensions[0];
	canvas.height = dimensions[1];
	const ctx = canvas.getContext('2d', { colorSpace: "display-p3" });
	
	const imageData = ctx.createImageData( 
		canvas.width,
		canvas.height
	);
	const data = imageData.data;
	
	// function to do the bilinear interpolation
	const mixFn = fourColorMixFn( ...fourColors );

	// loop over all of our pixels
	for ( let i = 0; i < data.length; i += 4 ) {
		
		// where are we?
		const pixelNumber = i / 4;
		const col = pixelNumber % canvas.width;
		const row = Math.floor( pixelNumber / canvas.width );
		// in percents...
		// TODO this is obviously where the confusion in pointsToSheetInContextSpace is coming from
		// 90 deg rotation? counting from the bottom rather than the top?
		// would be nice to figure it out
		const x = col / ( canvas.width - 1 );
		const y = row / ( canvas.height - 1 );

		// gray grid
// 		if ( col % 10 === 0 || row % 10 === 0 ) {
// 			data[i] = 122; // red
// 			data[i + 1] = 122; // green
// 			data[i + 2] = 122; // blue
// 			data[i + 3] = 255; // alpha
// 		
// 		} else {
		
		// interpolate in colorspace
		const pixelCoordsInInputSpace = mixFn( x, y );
		// output to P3
		const pixelCordsInDisplayP3 = convert(
			{ 
				space: inputSpace,
				coords: pixelCoordsInInputSpace
			}, 
			displayP3
		).coords;
		
		// write our pixels
		data[i] = percentToOctal( pixelCordsInDisplayP3[0] ); // red
		data[i + 1] = percentToOctal( pixelCordsInDisplayP3[1] ); // green
		data[i + 2] = percentToOctal( pixelCordsInDisplayP3[2] ); // blue
		data[i + 3] = 255; // alpha
		
		//} // grid if else
	}

	ctx.putImageData(imageData, 0, 0);
	return canvas;
	
}